<template>
  <div>
    <router-view v-if="canRenderRoute" />

    <!--提醒訊息-->
    <notice />
    <request />

    <!--廣告彈窗-->
    <commercial />

    <!--註冊體驗金領取彈窗-->
    <register-bonus-modal v-if="memberReady" />

    <!-- cookie policy -->
    <cookie-agree v-if="$store.getters.loadCompleted" />

    <!--Loading效果：需維持最後一個子節點。router-view 與 cookie-agree 會同時從 v-if 註解變成元件，
        頭尾都對不上時 Vue 會把中間的節點搬到前面，DOM 被搬動會讓轉圈動畫重新開始而頓一下；
        放在最後會先被尾端比對配對到，不會被搬動-->
    <loading />
  </div>
</template>
<script>
import Vue from 'vue'
import Loading from '@/components/loading'
import Notice from '@/components/modal/notice'
import Request from '@/components/modal/request'
import Commercial from '@/components/modal/commercial'
import { forceApp, showNotice, isPublicRoute } from '@/utils/tool'
import CookieAgree from '@/components/cookieAgree'
import RegisterBonusModal from '@/components/modal/registerBonusModal'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    Loading,
    Notice,
    Request,
    Commercial,
    CookieAgree,
    RegisterBonusModal
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters(['loadCompleted', 'brandReady', 'memberReady']),
    // loadCompleted 只解公開正文：brand API 失敗時僅渲染公開頁，其餘頁面等導向錯誤頁
    canRenderRoute() {
      return this.loadCompleted && (this.brandReady || isPublicRoute(this.$route))
    }
  },
  watch: {
    $route: function(to, from, next) {
      if (forceApp(to.name, this.$store.getters.permissionInfo.mobile_force_app)) {
        const self = this
        setTimeout(function() { window.location = self.$store.getters.urlInfo.appDownloadUrl }, 5000)
        showNotice(this.$t('Bao.downAppNotice'), function() {
          window.location = self.$store.getters.urlInfo.appDownloadUrl
        })
      }
    }
  },
  mounted() {
    if (this.$store.getters.token) {
      Vue.prototype.$socket.init()
    }
  },
  beforeDestroy() {

  },
  created() {

  },
  methods: {

  }
}
</script>
<style scoped>
</style>
